const THEMES = {
	LIGHT: "LIGHT",
	DARK: "DARK",
	NATURE: "NATURE",
};

export default THEMES;
